<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { AppButton, AuthGate } from '../../shared/ui';
import { useAuthStore } from '../../stores/auth';

const auth = useAuthStore();
const router = useRouter();
const resending = ref(false);
const error = ref<string | null>(null);
const flash = ref<string | null>(null);

async function onResend(): Promise<void> {
  resending.value = true;
  error.value = null;
  flash.value = null;
  try {
    await auth.resendVerification();
    flash.value = 'Письмо отправлено';
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Не удалось отправить письмо';
  } finally {
    resending.value = false;
  }
}

async function onLogout(): Promise<void> {
  await auth.logout();
  await router.replace({ name: 'login' });
}
</script>

<template>
  <AuthGate class="auth-gate--anchored">
    <div class="suspension-gate">
      <h1 class="suspension-gate__title">
        Рабочее пространство приостановлено
      </h1>
      <p class="suspension-gate__lead">
        Подтвердите почту, чтобы продолжить работу.
      </p>
      <div class="form__actions suspension-gate__actions">
        <AppButton
          variant="primary"
          :loading="resending"
          @click="onResend"
        >
          Отправить письмо снова
        </AppButton>
        <AppButton
          type="button"
          @click="onLogout"
        >
          Выйти
        </AppButton>
      </div>
      <p
        v-if="flash"
        class="suspension-gate__flash"
      >
        {{ flash }}
      </p>
      <p
        v-if="error"
        class="suspension-gate__error"
      >
        {{ error }}
      </p>
    </div>
  </AuthGate>
</template>

<style scoped>
.suspension-gate {
  width: 100%;
  text-align: center;
}

.suspension-gate__title {
  margin: 0 0 0.75rem;
  font-family: var(--font-ui);
  font-size: 1.05rem;
  font-weight: 600;
}

.suspension-gate__lead {
  margin: 0 0 1rem;
  color: var(--muted);
  font-size: 0.85rem;
}

.suspension-gate__actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
}

.suspension-gate__flash {
  margin: 0.75rem 0 0;
  font-size: 0.8rem;
  color: var(--text);
}

.suspension-gate__error {
  margin: 0.75rem 0 0;
  font-size: 0.8rem;
  color: var(--danger);
}
</style>
